import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ClipboardCheck, CheckCircle2 } from 'lucide-react';
import { API_URL } from '../utils/apiUrl';

const TestProcedureCard = ({ category }) => {
  const [proc, setProc] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!category) { setLoaded(true); return; }
    // Use query-param endpoint so categories containing '/' (e.g. "Giyim / Tekstil")
    // work — path-param variant rejects encoded slashes in FastAPI routing.
    axios.get(`${API_URL}/api/test-procedures/active`, { params: { category } })
      .then(r => setProc(r.data))
      .catch(() => setProc(null))
      .finally(() => setLoaded(true));
  }, [category]);

  if (!loaded) {
    return (
      <div className="border border-neutral-200 rounded-md bg-white p-6 shadow-sm" data-testid="procedure-loading">
        <p className="text-sm text-neutral-400">Test prosedürleri yükleniyor...</p>
      </div>
    );
  }

  if (!proc) {
    return (
      <section className="border border-neutral-200 rounded-md bg-neutral-50 p-6 md:p-8 mb-8" data-testid="procedure-empty">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-9 h-9 rounded-full bg-neutral-200 flex items-center justify-center">
            <ClipboardCheck className="w-4 h-4 text-neutral-500" />
          </div>
          <div>
            <h3 className="text-lg md:text-xl font-black tracking-tight text-neutral-700">Bu ürün hangi prosedürlere göre test edildi?</h3>
            <p className="text-xs text-neutral-500">Kategori: {category || '—'}</p>
          </div>
        </div>
        <p className="text-sm text-neutral-500 mt-3 italic">Bu kategori için test prosedürü yakında yayınlanacaktır.</p>
      </section>
    );
  }

  return (
    <section className="border border-neutral-200 rounded-md bg-white p-6 md:p-8 shadow-sm mb-8" data-testid="procedure-section">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-9 h-9 rounded-full bg-[#1C3B2A]/10 flex items-center justify-center">
          <ClipboardCheck className="w-4 h-4 text-[#1C3B2A]" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg md:text-xl font-black tracking-tight text-[#111]">Bu ürün hangi prosedürlere göre test edildi?</h3>
          <p className="text-xs text-neutral-500">{proc.category}</p>
        </div>
      </div>

      <div className="mt-5">
        <p className="text-base md:text-lg font-black text-[#1C3B2A] mb-2" data-testid="procedure-title">{proc.title}</p>
        <p className="text-sm text-neutral-600 leading-relaxed mb-5" data-testid="procedure-description">{proc.description}</p>

        {proc.criteria_list && proc.criteria_list.length > 0 && (
          <ul className="space-y-2 mb-5" data-testid="procedure-criteria-list">
            {proc.criteria_list.map((c, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-neutral-700">
                <CheckCircle2 className="w-4 h-4 text-[#1C3B2A] flex-shrink-0 mt-0.5" />
                <span>{c}</span>
              </li>
            ))}
          </ul>
        )}

        <div className="flex items-center gap-4 pt-4 border-t border-neutral-100 text-xs text-neutral-400 flex-wrap">
          <span data-testid="procedure-version">Versiyon: <span className="font-bold text-neutral-600">v{proc.version}</span></span>
          {proc.last_updated_at && (
            <span>Son güncelleme: <span className="font-semibold text-neutral-600">{new Date(proc.last_updated_at).toLocaleDateString('tr-TR')}</span></span>
          )}
        </div>
      </div>
    </section>
  );
};

export default TestProcedureCard;
